/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DistributionJobResponse } from '../../models/distribution-job-response';

export interface GetJob$Params {
  'Active-Tenant-Identifier': string;
  jobId: string;
}

export function getJob(http: HttpClient, rootUrl: string, params: GetJob$Params, context?: HttpContext): Observable<StrictHttpResponse<DistributionJobResponse>> {
  const rb = new RequestBuilder(rootUrl, getJob.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('jobId', params.jobId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DistributionJobResponse>;
    })
  );
}

getJob.PATH = '/distribution-jobs/{jobId}';
